<div class="bk-profile__container">
    <profile-nav>
        <profile-tab [tabTitle]="'User Information'">
            <user-information></user-information>
        </profile-tab>
        <profile-tab [tabTitle]="'Change Password'">
            <change-password></change-password>
        </profile-tab>
    </profile-nav>
</div>